import { render, staticRenderFns } from "./PosList.vue?vue&type=template&id=46b9af38&scoped=true&"
import script from "./PosList.vue?vue&type=script&lang=js&"
export * from "./PosList.vue?vue&type=script&lang=js&"
import style0 from "./PosList.vue?vue&type=style&index=0&id=46b9af38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b9af38",
  null
  
)

export default component.exports